<div (window:beforeunload)="unloadNotification($event)">
    <div class="modal-content">
        <div class="modal-header modal-header-blue" [ngStyle]="{'background': styleService?.brandingStyle?.backgroundColor || null, 'color': styleService?.brandingStyle?.textColor || null}">
            <h4 class="modal-title">
                <i [class]="icon"></i>
                <span class="ml-3"
                      [innerHtml]="title"></span>
            </h4>
            <!-- <button type="button" class="close button-light" aria-label="Close" (click)="modal.hide()">
                <span aria-hidden="true">&times;</span>
            </button> -->
        </div>
        <div class="modal-error animated fadeIn my-1"
             *ngIf="status === 'ERROR' && state.animatedButtonState !== 'SUBMITTING'">
            <div class="p-2"
                 [innerHtml]="('ERROR.' + error?.code) | translate: { amount: errorAmount }"></div>
        </div>
        <div class="modal-body"
             [ngClass]="(!hasFooter && buttons !== modalButtons.None) ? '' : 'body-pb-0'">
            <ng-content></ng-content>
        </div>
        <div *ngIf="!hasFooter && buttons !== modalButtons.None"
             class="modal-footer modal-footer-gray centered-content">
            <button class="btn btn-secondary mx-2"
                    type="button"
                    [hidden]="!(buttons % (2 * modalButtons.Cancel) >= modalButtons.Cancel)"
                    [attr.form]="formId"
                    (click)="onCancel()">
                {{ 'SHARED.COMPONENTS.BUTTON.CANCEL' | translate }}
            </button>
            <button class="btn btn-secondary mx-2"
                    type="button"
                    [hidden]="!(buttons % (2 * modalButtons.No) >= modalButtons.No)"
                    [attr.form]="formId"
                    (click)="onCancel()">
                {{ 'SHARED.COMPONENTS.BUTTON.NO' | translate }}
            </button>
            <button class="btn btn-secondary mx-2"
                    type="button"
                    [hidden]="!(buttons % (2 * modalButtons.Ok) >= modalButtons.Ok)"
                    [attr.form]="formId"
                    (click)="onCancel()">
                {{ 'SHARED.COMPONENTS.BUTTON.OK' | translate }}
            </button>
            <button class="btn btn-secondary mx-2"
                    type="button"
                    [hidden]="!(buttons % (2 * modalButtons.Close) >= modalButtons.Close)"
                    [attr.form]="formId"
                    (click)="onCancel()">
                {{ 'SHARED.COMPONENTS.BUTTON.CLOSE' | translate }}
            </button>
            <!-- <button class="btn btn-info mx-2" type="button" [hidden]="!(buttons % (2 * modalButtons.Preview) >= modalButtons.Preview)" [attr.form]="formId" (click)="onCancel()">
                {{ 'SHARED.COMPONENTS.BUTTON.PREVIEW' | translate }}
            </button> -->
            <button class="btn btn-info mx-2"
                    type="button"
                    [hidden]="!(buttons % (2 * modalButtons.Import) >= modalButtons.Import)"
                    [attr.form]="formId"
                    (click)="onCancel()">
                {{ 'SHARED.COMPONENTS.BUTTON.IMPORT' | translate }}
            </button>
            <app-component-animated-button [state]="saveButtonState"
                                           (stateChanged)="onAnimatedButtonChanged($event)"
                                           (clicked)="onSubmit($event)"
                                           [options]="modalOptions"
                                           [successText]="successText"
                                           [hidden]="!(buttons % (2 * modalButtons.Save) >= modalButtons.Save)"
                                           [disabled]="isDisabled">
                {{ 'SHARED.COMPONENTS.BUTTON.SAVE' | translate }}
            </app-component-animated-button>
            <app-component-animated-button [state]="saveButtonState"
                                           (stateChanged)="onAnimatedButtonChanged($event)"
                                           (clicked)="onSubmit($event)"
                                           [options]="modalOption"
                                           [hidden]="!(buttons % (2 * modalButtons.Yes) >= modalButtons.Yes)">
                {{ 'SHARED.COMPONENTS.BUTTON.YES' | translate }}
            </app-component-animated-button>
            <app-component-animated-button [state]="saveButtonState"
                                           (stateChanged)="onAnimatedButtonChanged($event)"
                                           (clicked)="onSubmit($event)"
                                           [options]="modalOption"
                                           [hidden]="!(buttons % (2 * modalButtons.Add) >= modalButtons.Add)">
                {{ 'SHARED.COMPONENTS.BUTTON.ADD' | translate }}
            </app-component-animated-button>
            <app-component-animated-button [state]="saveButtonState"
                                           (stateChanged)="onAnimatedButtonChanged($event)"
                                           (clicked)="onSubmit($event)"
                                           [options]="modalOption"
                                           [hidden]="!(buttons % (2 * modalButtons.Export) >= modalButtons.Export)">
                {{ 'SHARED.COMPONENTS.BUTTON.EXPORT' | translate }}
            </app-component-animated-button>
            <app-component-animated-button [state]="saveButtonState"
                                           (stateChanged)="onAnimatedButtonChanged($event)"
                                           (clicked)="onSubmit($event)"
                                           [options]="modalOption"
                                           [hidden]="!(buttons % (2 * modalButtons.Sort) >= modalButtons.Sort)">
                {{ 'SHARED.COMPONENTS.BUTTON.SORT' | translate }}
            </app-component-animated-button>
        </div>
    </div>
</div>
